export enum BlockReason {
  LOST = 'Lost',
  STOLEN = 'Stolen',
}
